module.exports = __webpack_public_path__ + "static/media/MedMal-black-icon.e3ff74a4.svg";